import {
  getComments,
  addComments,
  addCommentsReply,
  getCommentsReply,
} from '@/api'

const types = {
  DEL_SAY: 'DEL_SAY',
  ADD_SAY: 'ADD_SAY',
  SAY_LIST: 'SAY_LIST',
  FETCH_REPLY: 'FETCH_REPLY',
  TOGGLE_REPLY: 'TOGGLE_REPLY',
  SAY_REPLY_LIST: 'SAY_REPLY_LIST',
  TOGGLE_SUB_REPLY: 'TOGGLE_SUB_REPLY',
}
const Scene = {
  state: {
    SAY_LIST: [],
    SAY_LIST_COUNT: 0,
    SAY_LIST_STATUS: false,
    SAY_REPLY_LIST: {
      count: 0,
      list: [],
    },
    ADD_SAY: false,
    DEL_SAY: false,
    replyIndex: 1,
  },
  actions: {
    // 说说列表
    [types.SAY_LIST]: async ({ rootGetters, state, commit }, opts) => {
      let videoId = rootGetters.getVideoId
      let { pageIndex, pageCount } = opts
      state.SAY_LIST_STATUS = false
      let res = await getComments(videoId, pageIndex, pageCount)
      return commit(types.SAY_LIST, res)
    },
    // 回复列表
    [types.SAY_REPLY_LIST]: async ({ commit }, fkId) => {
      let res = await getCommentsReply(fkId)
      return commit(types.SAY_REPLY_LIST, res)
    },
    // 发表说一说
    [types.ADD_SAY]: async ({ dispatch, commit }, opts) => {
      let res
      if (opts.id) {
        res = await addCommentsReply(opts)
      } else {
        res = await addComments(opts)
      }
      // dispatch('SAY_LIST', opts.fk_video_id)
      return commit(types.ADD_SAY, res)
    },
    [types.FETCH_REPLY]: async ({ state, commit }, obj) => {
      const { id, index } = obj
      const totalReplyCount = state[types.SAY_LIST][index].total_replays
      const replyListCount = state[types.SAY_LIST][index].replyList.length

      if (replyListCount < totalReplyCount) {
        const res = await getCommentsReply(id, state.replyIndex)
        state.replyIndex++
        return commit(types.FETCH_REPLY, res)
      } else {
        return commit(types.TOGGLE_REPLY, index)
      }
    },
    [types.TOGGLE_SUB_REPLY]: ({ commit }, obj) => {
      return commit(types.TOGGLE_SUB_REPLY, obj)
    },
  },
  mutations: {
    [types.SAY_LIST]: (state, data) => {
      data.list.map(it => {
        it.showReply = false
        it.replyList = []
      })
      state[types.SAY_LIST] = state[types.SAY_LIST].concat([...data.list])
      state[types.SAY_LIST_COUNT] = data.count
      state.SAY_LIST_STATUS = true
    },
    [types.SAY_REPLY_LIST]: (state, data) => {
      state[types.SAY_REPLY_LIST] = data
    },
    [types.ADD_SAY]: (state, data) => {
      let sayList = state[types.SAY_LIST]
      if (data.fk_comment_id) {
        // 回复
        sayList.map(it => {
          if (it.id === data.fk_comment_id) {
            it.total_replays += 1
            it.replyList.unshift(data)
          }
        })
      } else {
        // 留言
        state[types.SAY_LIST].push(data)
      }
    },
    [types.FETCH_REPLY]: async (state, data) => {
      const sayList = state[types.SAY_LIST]
      sayList.map((it, idx) => {
        if (it.id === data.id) {
          sayList[idx].replyList.push(...data.replay_items)
          sayList[idx].showReply = !sayList[idx].showReply
        }
      })
    },
    [types.TOGGLE_REPLY]: (state, index) => {
      state[types.SAY_LIST][index].showReply = !state[types.SAY_LIST][index]
        .showReply
    },
    [types.TOGGLE_SUB_REPLY]: (state, obj) => {
      const { gIdx, cIdx } = obj
      state[types.SAY_LIST][gIdx].comment_replay_items[cIdx].showReply = !state[
        types.SAY_LIST
      ][gIdx].comment_replay_items[cIdx].showReply
    },
  },
  getters: {
    getComments(state) {
      return state[types.SAY_LIST]
    },
    hasSayMore(state) {
      return state[types.SAY_LIST].length < state[types.SAY_LIST_COUNT]
    },
    getFetchSayStatus(state) {
      return state.SAY_LIST_STATUS
    },
  },
}

export default Scene
